import { render, staticRenderFns } from "./grossing-touch-portion-card.vue?vue&type=template&id=089403d0&scoped=true&"
import script from "./grossing-touch-portion-card.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-portion-card.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-portion-card.scss?vue&type=style&index=0&id=089403d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089403d0",
  null
  
)

export default component.exports